import styled from 'styled-components'
import { Colors } from '../../../../../styles'
import { TableCell, TableHead, TextField } from '@material-ui/core'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { BlueDelete } from '../../../../../components/svg/svg.component'

export const Modal = styled.dialog`
  border-radius: 4px;
  max-width: 85vw;
  padding: unset;
  z-index: 100;
  border: 1px solid ${Colors.white};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const ModalHeader = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.softBlue};
`
export const ModalTitle = styled.label`
  color: ${Colors.white};
  font-weight: 600;
  font-size: 24px;
`

export const ModalContent = styled.div`
  gap: 8px;
  display: flex;
  overflow-y: auto;
  max-height: 55rem;
  padding: 16px 24px;
  flex-direction: column;
  background-color: ${Colors.white};
`

export const CloseButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
`

export const TopContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TotalQuantity = styled.label`
  font-weight: 600;
  font-size: 24px;
  color: ${Colors.cancelTextColor};
`

export const TableHeaderTimeCell = styled(TableCell)`
  top: 35px;
  left: unset;
  padding: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  position: sticky;
  background-color: #d0e2ff;
  color: ${Colors.tundora};
  min-width: ${(props) => props.minWidth}px;
`

export const TableHeaderCell = styled(TableCell)`
  top: 0;
  z-index: 1;
  left: unset;
  padding: 8px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  position: sticky;
  background-color: ${Colors.pattensBlue};
  color: ${Colors.tundora};
  min-width: ${(props) => props.minWidth}px;
`
export const TableHeader = styled(TableHead)`
  background-color: ${Colors.white};
`
export const TableBodyCell = styled(TableCell)`
  border: none;
  padding: 4px 16px;
`

export const ActionWrapper = styled.div`
  border: 2px solid rgb(230, 230, 230);
  padding: 2px;
  border-radius: 100%;
  max-width: 30px;
  max-height: 30px;
  min-width: 30px;
  min-height: 30px;
  display: flex;
  background: linear-gradient(rgb(56, 56, 56) 0%, rgb(255, 255, 255) 100%);
`

export const ActionInnerGo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.disabled ? Colors.actionDisabled : Colors.actionGo};
  justify-content: center;
  border-radius: 100%;
`

export const ActionInnerStop = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.disabled ? Colors.actionDisabled : Colors.actionStop};
  justify-content: center;
  border-radius: 100%;
`

export const ActionLabel = styled.label`
  font-size: 8px;
  font-weight: 700;
  color: ${Colors.white};
`
export const WrapperDelete = styled.div`
  height: 40px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`

export const StyledDateTimePicker = styled(DateTimePicker)`
  width: 100%;
  .k-picker-wrap.k-state-default {
    padding: 0;
    border-bottom: 2px solid ${Colors.alto};
  }
  input.k-input {
    font-size: 12px !important;
    font-weight: 600 !important;
    color: ${Colors.actionDisabled} !important;
  }
  .k-animation-container {
    z-index: 9999 !important;
  }
`
export const StyledTextField = styled(TextField)`
  & input {
    font-size: 12px;
    font-weight: 600;
    color: ${Colors.actionDisabled};
  }
`
export const DeleteIcon = styled(BlueDelete)`
  cursor: ${(p) => (p.disable ? 'not-allowed' : 'pointer')};
  color: ${(p) => (p.disable ? Colors.softGrey : Colors.softBlue)};
`

export const WrapperTable = styled.div`
  overflow: auto;
  border: 1px solid #eee;
  width: 100%;
  overflow-x: auto;
  min-height: 35rem;
`
export const ActionContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`
export const NotFoundCell = styled.td`
  height: 80px;
  color: #888;
  text-align: center;
`
export const LoadingCell = styled.td`
  height: 28rem;
  text-align: center;
`
